import { WizardService } from '../services/wizard.service';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { StepModel } from '../model/steps.model';
import { AuthService } from '@/core/services/auth.service';

@Component({
    selector: 'app-wizard',
    templateUrl: './wizard.component.html',
    styleUrls: ['./wizard.component.scss'],
    standalone: false,
})
export class WizardComponent implements OnInit, OnDestroy {
    firstName: string = '';
    lastName: string = '';
    currentStep?: StepModel;
    currentStepSub?: Subscription;

    constructor(
        private readonly wizardService: WizardService,
        private readonly router: Router,
        private readonly authService: AuthService,
    ) {}

    ngOnInit(): void {
        if (this.authService.authenticatedValidUser) {
            void this.router.navigate(['/']);
            return;
        } else if (!this.authService.authenticated) {
            void this.router.navigate(['/login']);
            return;
        }

        this.wizardService.setCurrentStep({ stepIndex: 1, isComplete: false });
        this.currentStepSub = this.wizardService.getCurrentStep().subscribe((step: StepModel) => {
            this.currentStep = step;
        });
    }

    ngOnDestroy(): void {
        this.currentStepSub?.unsubscribe();
    }
}
